import React from 'react';
import { RadioSelect } from '@keen.io/ui-core';
import Row from '../../../../../Row';
import Label from '../../../../../Label';
import { Container, ValueModeContainer } from './ValueMode.styles';
import { VALUE_MODE_SETTINGS } from './constants';

var ValueMode = function ValueMode(_ref) {
  var label = _ref.label,
      valueMode = _ref.valueMode,
      onChange = _ref.onChange;
  return React.createElement(Container, null, React.createElement(Row, null, React.createElement(Label, null, label), React.createElement(ValueModeContainer, null, React.createElement(RadioSelect, {
    activeItem: valueMode ? valueMode : VALUE_MODE_SETTINGS[0].value,
    items: VALUE_MODE_SETTINGS,
    onClick: function onClick(_ref2) {
      var value = _ref2.value;
      var valueMode = value;
      onChange({
        valueMode: valueMode
      });
    }
  }))));
};

export default ValueMode;